import { useSubsStore } from '@/state/MsgTreeProvider'
import {
  selectSubRenderState,
  type SubRowVariant,
  type SubsStoreState,
} from '@/msgdeskRuntime/state'
import { RowTemplateHost } from '../rowTemplates/RowTemplateHost'

export type { SubRowVariant }

// Lookup wrapper. The row template host owns the legacy bridge contract; layouts only arrange controls/data.
export function SubRow({
  elId,
  variant = 'auto',
  sourceMode,
}: {
  elId: number
  variant?: SubRowVariant
  sourceMode?: string
}) {
  const { state } = useSubsStore()
  const sub = selectSubRenderState(state as SubsStoreState, elId)
  if (!sub) return null

  return <RowTemplateHost sub={sub} variant={variant} sourceMode={sourceMode} />
}
